export const INIT_GET_POLICY_STATEMENT_CLOSING = 'INSURANCE::INIT_GET_POLICY_STATEMENT_CLOSING';
export const RESPONSE_GET_POLICY_STATEMENT_CLOSING = 'INSURANCE::RESPONSE_GET_POLICY_STATEMENT_CLOSING';
export const ERROR_GET_POLICY_STATEMENT_CLOSING = 'INSURANCE::ERROR_GET_POLICY_STATEMENT_CLOSING';
export const CLEAR_GET_POLICY_STATEMENT_CLOSING = 'INSURANCE::CLEAR_GET_POLICY_STATEMENT_CLOSING';

export const INIT_GET_POLICY = 'INSURANCE::INIT_GET_POLICY';
export const RESPONSE_GET_POLICY = 'INSURANCE::RESPONSE_GET_POLICY';
export const ERROR_GET_POLICY = 'INSURANCE::ERROR_GET_POLICY';
export const CLEAR_GET_POLICY = 'INSURANCE::CLEAR_GET_POLICY';
